import React from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import { Box, CircularLoader, Link, Typography } from "@bca/ui-library";

import KeyDecisionMakerContainer from "../KeyDecisionMakerContainer";
import { KeyDecisionMakerText } from "../mechanicalReport/styledElements/KeyDecisionMakerText";
import PoundSignInCircleSVG from "../Icons/PoundSignInCircleSVG";

const StyledLink = styled(Link)`
  ${css({
    fontSize: "body-small",
    textAlign: "center",
    paddingRight: [10, 0],
  })}
`;

interface ValuationPriceProps {
  price: string | null;
  anchorLink: string;
  isBCAValuationLoading: boolean;
  isBCAValuationAvailable: boolean;
}

const ValuationPrice: React.FunctionComponent<ValuationPriceProps> = ({
  price,
  anchorLink,
  isBCAValuationLoading,
  isBCAValuationAvailable,
}) => {
  const formatPrice = (price: string | null): string => {
    if (!isBCAValuationAvailable) return "Data Unavailable";
    const priceWithoutWhiteSpace = price?.toString()?.replace(/\s/g, "");
    const formattedPrice = priceWithoutWhiteSpace?.replace(
      /\B(?=(\d{3})+(?!\d))/g,
      ","
    );
    return `£${formattedPrice}`;
  };

  return (
    <KeyDecisionMakerContainer>
      <KeyDecisionMakerText>
        {isBCAValuationLoading ? (
          <>
            <Box marginTop="2px">
              <PoundSignInCircleSVG width="24px" height="24px" />
            </Box>
            <Typography
              variant="h6"
              color="footer-blue"
              m={0}
              marginTop={isBCAValuationAvailable ? 0 : "2px"}
            >
              Pending
            </Typography>
            <CircularLoader title="Load BCA Valuation" width={15} height={15} />
          </>
        ) : (
          <>
            {isBCAValuationAvailable && (
              <Box marginTop="2px">
                <PoundSignInCircleSVG width="24px" height="24px" />
              </Box>
            )}
            <Typography
              variant="h6"
              color="footer-blue"
              m={0}
              marginTop={isBCAValuationAvailable ? 0 : "2px"}
            >
              {formatPrice(price)}
            </Typography>
          </>
        )}
      </KeyDecisionMakerText>
      <StyledLink
        href={anchorLink}
        color="primary-light-blue"
        underline="always"
      >
        BCA Valuation
      </StyledLink>
    </KeyDecisionMakerContainer>
  );
};

export default ValuationPrice;
